import styled, { css } from 'styled-components';
import { FONT_COLOR, FONT_FAMILY, FONT_FAMILY_HEADING } from '@gr-monorepo/common/public/ui/constants/colors';

const headingBase = css`
  margin: 0;
  color: ${FONT_COLOR};
`;

const largeHeadingBase = css`
  ${headingBase}
  font-family: ${FONT_FAMILY_HEADING};
  font-weight: 800;
`;

const smallHeadingBase = css`
  ${headingBase}
  font-family: ${FONT_FAMILY};
  font-weight: 700;
`;

export const H1 = styled.h1`
  ${largeHeadingBase}
  font-size: 40px;
  line-height: 48px;
`;

export const H2 = styled.h2`
  ${largeHeadingBase}
  font-size: 32px;
  line-height: 36px;
`;

export const H3 = styled.h3`
  ${smallHeadingBase}
  font-size: 24px;
  line-height: 28px;
`;

export const H4 = styled.h4`
  ${smallHeadingBase}
  font-size: 20px;
  line-height: 24px;
`;
